import React from "react";

interface ButtonProps {
  label: React.ReactNode;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void; // Accept event parameter
  className: string; // Require the full className to be passed in
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  style?: React.CSSProperties; // Add inline style prop
}

const Button: React.FC<ButtonProps> = ({
  label,
  onClick,
  className,
  type = "button",
  disabled = false,
  style,
}) => {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`${className} ${disabled ? "opacity-50 cursor-not-allowed" : ""}`} // Apply static classes
      style={style} // Apply dynamic inline styles
    >
      {label}
    </button>
  );
};

export default Button;
